import React from 'react';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import ButtonRow from '../../../Elements/ButtonRow';
import ErrorMessage from '../../../Elements/ErrorMessage';
import ContactService from '../../../Services/contactService';
import ContactSearchParams from './ContactSearchParams';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import ContactItem from '../../../Domain/ContactItem';
import EditContactWindowDescription from './EditContactWindowDescription';
import RelatedContacts from './RelatedContacts';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import GeneralEditPanelBase from '../../../Elements/GeneralEditPanelBase';
import ClientPOCExportSearchParams from './ClientPOCExportSearchParams';
import ClientPOCExportWindowDescription from './ClientPOCExportWindowDescription';

export default class ContactAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    const searchItem = new ContactSearchParams();
    if (this.props.ClientId) searchItem.ClientId = this.props.ClientId;

    this.state = {
      selectedContact: null,
      shownPanel: ShownPanelsEnum.None,
      searchItem,
    };

    this.refresh = this.refresh.bind(this);
    this.showPanel = this.showPanel.bind(this);
    ContactItem.editFunction = this.editContact.bind(this);
    ContactItem.lockFunction = this.lockFunction.bind(this);
    RelatedContacts.clickOnContactId = this.clickOnRelatedContactsContactId.bind(this);
  }

  lockFunction(id, item) {
    if (item.StatusCode === 5) return;

    item.IsActive = !item.IsActive;
    item.DisableAddressValidation = 'true';

    ContactService.EditContact(item)
      .then((result) => {
        if (result.error) ErrorMessage.SetErrorMessage(result.error);
        else this.refresh();
      })
      .catch(() => ErrorMessage.SetErrorMessage('LA76'));
  }

  editContact(contactId, item) {
    this.setState({
      shownPanel: ShownPanelsEnum.EditItem,
      selectedContact: item,
    });
  }

  clickOnRelatedContactsContactId(id) {
    const searchItem = { ContactId: id.toString() };
    this.setState({ searchItem });
  }

  showPanel(panelId) {
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
    this.setState({ shownPanel: ShownPanelsEnum.None });
  }

  renderPanels() {
    switch (this.state.shownPanel) {
      case ShownPanelsEnum.AddNewItem:
        EditContactWindowDescription.itemType = ContactItem;
        return (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={new ContactItem()}
            clickOnCancel={() => {
              this.setState({ shownPanel: ShownPanelsEnum.None });
            }}
            clickOnSave={this.refresh}
            windowDescription={EditContactWindowDescription}
            errorCode={'CA86'}
          />
        );
      case ShownPanelsEnum.EditItem:
        return (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedContact}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={this.refresh}
            windowDescription={EditContactWindowDescription}
            errorCode={'CA97'}
          />
        );
      case ShownPanelsEnum.ClientPOCExport:
        return (
          <GeneralEditPanelBase
            editedItem={new ClientPOCExportSearchParams()}
            onClose={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            panelDescription={ClientPOCExportWindowDescription}
            popup={true}
            errorCode='CA108'
            maxWidth={800}
            minHeight={400}
          />
        );
      default:
        return null;
    }
  }

  renderButtonsAndPanels() {
    return (
      <ButtonRow
        colors={[ButtonColorsEnum.Primary, ButtonColorsEnum.Secondary]}
        labels={['Create', 'POC List Export']}
        keys={[ShownPanelsEnum.AddNewItem, ShownPanelsEnum.ClientPOCExport]}
        icons={['fa-solid fa-plus-circle', 'fa-solid fa-file-export']}
        roleKeys={['ClientContact_ActionButton_CreateEdit', 'report_clientpocexport_run']}
        value={this.state.shownPanel}
        onClick={this.showPanel}
      />
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        {this.renderPanels()}
        <TabOfDataTable
          type={ContactItem}
          serviceFunction={ContactService.GetContactListBySearching}
          convertDBItemsFunction={ContactService.ConvertDBItems}
          searchItem={this.state.searchItem}
          searchParamsType={ContactSearchParams}
          showSearchStrip={true}
          clickOnStartSearch={(searchItem) => this.setState({ searchItem })}
          errorCode='CA130'
        />
      </div>
    );
  }
}
